export default __webpack_public_path__ + "static/fakegoogle_4-90731392a2e7c597a979b1868af3321f.jpg";